// extracted by mini-css-extract-plugin
export var layout = "default-module--layout--omG36";
export var navigation = "default-module--navigation--a5dyY";
export var logo = "default-module--logo--2545U";
export var name = "default-module--name--74AIN";
export var subtitle = "default-module--subtitle--jIgOe";